export const EditLineIcon = props => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M4.27614 10.593L11.0375 3.83158L10.0947 2.88877L3.33333 9.65022V10.593H4.27614ZM4.82843 11.9263H2V9.09788L9.62333 1.47456C9.88373 1.21421 10.3058 1.21421 10.5661 1.47456L12.4518 3.36018C12.7121 3.62052 12.7121 4.04264 12.4518 4.30298L4.82843 11.9263ZM2 13.2597H14V14.593H2V13.2597Z'
      fill='#4361EE'
    />
  </svg>
);
